import React, { useState } from "react";
import { Grid } from "@mui/material";
// import { Row } from "components/common";
import TransactionCharts from "./TransactionCharts";
import NumberCharts from "./NumberCharts";
import tableViewIcon from "assets/icons/ic_list_grey_A.svg";
import pieViewIcon from "assets/icons/ic_pie_chart_grey_A.svg";
import "./style.css";
const IconButton = ({
  title = "",
  imageUrl = "",
  size = "medium",
  isActive = false,
  onClick = "",
}) => {
  return (
    <div
      className={`flex align-center item  ${isActive ? "item-active" : ""}`}
      onClick={onClick}
    >
      <img
        src={imageUrl}
        alt="IconButton"
        className={`image ${size} ${isActive ? "image-active" : ""}`}
        title={title}
      />
    </div>
  );
};

const Charts = ({ preTransactionCounts, transactionCounts, isLoading }) => {
  const [isChart, changeChartView] = useState(true);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          item
          xs={1}
          lg={1}
          md={1}
          sx={{ position: "relative", top: "25px" }}
        >
          <div className="flex row border">
            <IconButton
              title="Chart View"
              isActive={isChart}
              size="medium"
              onClick={() => {
                changeChartView(true);
              }}
              imageUrl={pieViewIcon}
            />
            <IconButton
              title="Table View"
              isActive={!isChart}
              size="large"
              onClick={() => {
                changeChartView(false);
              }}
              imageUrl={tableViewIcon}
            />
          </div>
        </Grid>
      </Grid>
      {isChart && (
        <Grid container spacing={2} columns={{ xs: 1, sm: 1, md: 12 }}>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <TransactionCharts
              title={"Pre-Transaction Planning"}
              transactionCounts={preTransactionCounts}
              isLoading={isLoading}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <TransactionCharts
              title={"Transactions"}
              transactionCounts={transactionCounts}
              isLoading={isLoading}
            />
          </Grid>
        </Grid>
      )}
      {!isChart && (
        <Grid container spacing={2} columns={{ xs: 1, sm: 1, md: 12 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <NumberCharts
              title={"Pre-Transaction Planning"}
              transactionCounts={preTransactionCounts}
              isLoading={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <NumberCharts
              title={"Transactions"}
              transactionCounts={transactionCounts}
              isLoading={isLoading}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Charts;
